<template>
    <div>
        <label>{{label}}</label>
        <textarea
            class="form-control"
            :class="invalid ? 'is-invalid' : ''"
            ref="suneditor"
            :name="name"
            :value="val"
        ></textarea>
        <small class="invalid-feedback font-weight-bold" v-if="validation">
            <span v-for="(el, key) in invalid" :key="key">{{el}}</span>
        </small>
    </div>
</template>

<script>
    import suneditor from 'suneditor'
    import plugins from 'suneditor/src/plugins'
    import pl from 'suneditor/src/lang/pl'

    export default {
        props: ['name', 'label', 'value', 'invalid'],
        data(){
            return {
                editor: null,
                val: this.$props.value,
                validation: null,
            }
        },
        mounted(){

            this.$nextTick(() => {
                let _this = this;

                _this.editor = suneditor.create(_this.$refs.suneditor, {
                    plugins: plugins,
                    buttonList: [
                        ['undo', 'redo'],
                        ['font','fontSize'],
                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                        ['fontColor', 'hiliteColor', 'textStyle'],
                        ['removeFormat'],
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                        ['table', 'link'],
                        ['fullScreen', 'showBlocks'],
                        ['save'],
                    ],
                    lang: pl,
                    width: '100%',
                    minHeight: '300px',
                    height: 'auto',
                    font: ['Lato, sans-serif', 'Rozha One, serif'],
                    stickyToolbar: '60px',
                })

                _this.editor.onChange = function ()
                {
                    _this.editor.save();
                    _this.$emit('change', this.getContents());
                    _this.validation = null;
                }

                _this.resetButtonList($(window).width());
            });

            let _this = this;
            $(window).on('resize', function(){
                _this.resetButtonList($(this).width());
            });
        },
        watch: {
            value(el){
                this.editor.setContents(el);
            },
            invalid(val){
                this.validation  = val;
            }
        },
        methods: {
            resetButtonList(width){
                if(width < 768)
                {
                    this.editor.setToolbarButtons([
                        ['undo', 'redo'],
                        [':p-More Paragraph-default.more_paragraph', 'font', 'fontSize', 'formatBlock'],
                        [':t-More Text-default.more_text', 'bold', 'underline', 'italic', 'strike', 'fontColor', 'hiliteColor', 'textStyle', 'removeFormat'],
                        [':e-More Line-default.more_horizontal', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'lineHeight'],
                        [':r-More Rich-default.more_plus', 'table', 'link'],
                        ['-right', ':i-More Misc-default.more_vertical', 'fullScreen', 'showBlocks', 'save']
                    ]);
                }
                else if(width < 1024)
                {
                    this.editor.setToolbarButtons([
                        ['undo', 'redo'],
                        [':p-More Paragraph-default.more_paragraph', 'font', 'fontSize'],
                        ['bold', 'underline', 'italic', 'strike'],
                        [':t-More Text-default.more_text', 'fontColor', 'hiliteColor', 'textStyle'],
                        ['removeFormat'],
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                        ['-right', ':i-More Misc-default.more_vertical', 'fullScreen', 'showBlocks', 'save'],
                        ['-right', ':r-More Rich-default.more_plus', 'table', 'link']
                    ]);
                }
                else
                {
                    this.editor.setToolbarButtons([
                        ['undo', 'redo'],
                        ['font','fontSize'],
                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                        ['fontColor', 'hiliteColor', 'textStyle'],
                        ['removeFormat'],
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                        ['table', 'link'],
                        ['fullScreen', 'showBlocks'],
                        ['save'],
                    ]);
                }

            }
        }
    }
</script>
